import mediumZoom from 'medium-zoom';

import eachElement from 'Utils/eachElement.js';

document.addEventListener('DOMContentLoaded', () => {
	/* Add template to body */
	if (!document.querySelector('#zoom-template')) {
		document.body.insertAdjacentHTML('beforeend', `<template id="zoom-template">
			<div id="zoom-wrapper">
				<div id="zoom-container"></div>
				<aside>Caption</aside>
			</div>
		</template>`);
	}

	/* Register zoomable images */
	const zoom = mediumZoom('img[data-lightbox], a[data-lightbox] > img', {
		template: '#zoom-template',
		container: '#zoom-container',
	});

	/* Set caption */
	zoom.on('open', event => {
		/* Tick to allow the DOM to be appended */
		requestAnimationFrame(() => {
			const caption = event.target.getAttribute('alt') || event.target.getAttribute('title') || '';
			const aside = document.querySelector('#zoom-wrapper aside');

			if (aside) {
				aside.textContent = caption;
			}
		});
	});

	/* Prevent old-style lightbox links from navigating */
	eachElement('a[data-lightbox]', element => {
		element.addEventListener('click', event => {
			event.preventDefault();
			return false;
		});
	});
});
